import http from '@/utils/http';
import questionnaireApi from '@/api/questionnaire';
import bulletinApi from '@/api/bulletin';
import communicationApi from '@api/communication';
import { Toast } from 'vant';

module.exports = {
  /**
   * 更新通知状态为已读状态
   * @param params
   * @returns {Promise<unknown>}
   */
  updateReadStatus(params) {
    return http.get('/workscene/updateReadStatus', params).then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw res;
      }
    });
  },
  getUserInfo(payload) {
    // return new Promise(resolve => {
    //   resolve({
    //     // 用户姓名
    //     name: '测试',
    //     // 员工id
    //     userId: 1637377575,
    //     // api调用token,aa免登录
    //     token,
    //     // 广场Id
    //     plazaId: 1002294,
    //     // 广场名称
    //     plazaName: '北京丰科万达广场',
    //     // 租户Id
    //     tenantId: 2021072700038,
    //     // 角色类型
    //     roleType: 1,
    //     // 店铺id
    //     storeId: 3062954,
    //     // 电话号
    //     mobile: '1777777777',
    //   });
    // });
    const header = {
      userId: '123',
    };
    return http
      .get(
        '/phoenix/phoenix/arctic/v1/merchant/user/store/staff',
        payload,
        header
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          Toast({
            message: res.message || '上传失败',
            duration: 3000,
            position: 'top',
          });
          throw res;
        }
      });
  },
  getStoreInfo(params) {
    const headers = {
      accept: 'application/json',
    };
    return http
      .get(
        `/base/base/v1/store/queryStoreInfo?storeCode=${params.storeCode}`,
        {},
        headers
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  questionnaireApi,
  bulletinApi,
  communicationApi,
};
